import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpClientJsonpModule ,HTTP_INTERCEPTORS} from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
// import { environment } from '../../environments/environment';
import { AppTokenHandler } from '../CommonService/app-token-handler';
import { Router } from '@angular/router';
import { ProgressService } from './progress.service';
import { map } from 'rxjs/operators';
//import { ConfigService } from './ConfigService';
import { environment } from 'src/environments/environment';

@Injectable()
export class DataService {

     apiUrl:  string= '';
    private httpDataServiceOptions: any;
    private httpHeaderFileDownload: any;
    private httpHeaderFileUpload: any;
    referralURL: string = '';
    roleList: string[] = [];
    isRole = false;
    private _data: any;
 
    constructor(private appToken: AppTokenHandler,
        //private config : ConfigService,
        private http: HttpClient, private route: Router, private spinnerService: ProgressService) {
            this.apiUrl = environment.serviceBaseUrl;
     
      this.httpDataServiceOptions = {
        headers: new HttpHeaders({
            // 'AUTHA': this.appToken.getSessionToken(),
            'Content-Type': 'application/json'
        }),
        withCredentials: true

    };
        this.httpHeaderFileDownload = {

            headers: new HttpHeaders({

                access_token: this.appToken.getSessionToken()
            }),
            responseType: 'blob',
            withCredentials: true
        };
        this.httpHeaderFileUpload = {
            // headers: new HttpHeaders({
            //     access_token: this.appToken.getSessionToken()
            // }),
            // withCredentials: true
        };
    }
    get(url: any, id = null, param = null, param1 = null) {
      //  this.apiUrl = this.config.settings.serviceBaseUrl;
        let URL = this.apiUrl + url;
        if (id != null) {
            URL += '/' + id;
        }
        if (param != null) {
            URL += '/' + param;
        }
        if (param1 != null) {
            URL += '/' + param1;
        }
         var data = this.http.get(URL, this.httpDataServiceOptions)
         .pipe(map(response => response), catchError(this.handleError));
        return data;
    }
    create(url: any, resource: any) {
        //this.apiUrl = this.config.settings.serviceBaseUrl;
        return this.http.post<any>(this.apiUrl + url, resource, this.httpDataServiceOptions)
            .pipe(
                map(response => response), catchError(this.handleError)
            );
    }

    update(url:any, resource:any, parms:any) {
      //  this.apiUrl = this.config.settings.serviceBaseUrl;
        return this.http.post(this.apiUrl + url, JSON.stringify(resource), this.httpDataServiceOptions)
            .pipe(map(response => response), catchError(this.handleError));
    }
    Login(Email: string = '', AzureToken: string = '') {
        const body: any = null;
        const httpOptions = {
            headers: new HttpHeaders({ azure_token: AzureToken }), withCredentials: true
        }
        return this.http.get(environment.tokenPath, httpOptions).pipe(catchError(this.handleError));
    }

    LoginWithEmail(Email: string = '') {
        const body: any = null;
        const tokenpath = environment.tokenPath;
        //return this.http.get(tokenpath+'/'+ Email, { withCredentials: true }).pipe(catchError(this.handleError));
        return this.http.get(tokenpath, { params: {email : Email}, withCredentials: true }).pipe(catchError(this.handleError));
    
    }
   
    Download(Id: any) {
        return this.http.post(environment.APIEndpoint + 'api/ClientMemo/GetAttachmentbyAttachmentByID?Id=' + Id, { withCredentials: true })
        .pipe(map(data => data));
    }

    GetData(_url: string) {
        _url = environment.serviceBaseUrl + _url;
        return this.http.get(_url, { withCredentials: true }).pipe(catchError(this.handleError));
    }

    DeleteSelectedMail(Mailobj: any) {
        return this.http.post(environment.APIEndpoint + 'api/ClientMemo/DeleteSelectedMail', Mailobj, { withCredentials: true }).
            pipe(
            );
    }

    SendMemoListMail(Mailobj: any) {
        return this.http.post(environment.APIEndpoint + 'api/ClientMemo/SendMemoListMail', Mailobj, { withCredentials: true }).
            pipe(
            );
    }
    GetDataById(_url: string, _id: string) {
        _url = environment.serviceBaseUrl + _url + '/' + _id;
        return this.http.get(_url, { withCredentials: true }).pipe(catchError(this.handleError));
    }

    // ExecuteUnadjustedAdvanceMailers(_url: string, _id: string) {
    //     _url = environment.serviceBaseUrl + _url + '/' + _id;
    //     return this.http.get(_url, { withCredentials: true }).pipe(catchError(this.handleError));
    // }

    PostData(_url: string, _postdata: any) {
        _url = environment.serviceBaseUrl + _url;
        return this.http.post(_url, _postdata, { withCredentials: true }).pipe(catchError(this.handleError));
    }

    PostDataToken(_url: string, objParam: any, token: string) {
        const myheader = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        _url = environment.serviceBaseUrl + _url;
 
        // if (_param != null) {
        //     _url += '/' + _param;
        // }
        // if (_param1 != null) {
        //     _url += '/' + _param1;
        // }

        const paramsdata = new HttpParams()
      .set('value', objParam)
      .set('token', token);

        return this.http.post(_url,{params : paramsdata}, { withCredentials: true }).pipe(catchError(this.handleError));
    }

    private handleError(error: Response) {
        return throwError(error);
    }

    postfile(url:string, formData:any) {
        this.apiUrl = environment.serviceBaseUrl;
        return this.http.post<any>(this.apiUrl + url, formData, this.httpHeaderFileUpload)
            .pipe(
        );
    }

    ContainsSpecialCharacters(searchString: string) {
        let IsValidString = true;
        if (searchString.length > 0) {
            const regex = /^[A-Za-z0-9 ]+$/;
            IsValidString = regex.test(searchString);
        }
        return (IsValidString === true ? false : true);
    }

    LogoutUser(_url: string) {
        _url = environment.serviceBaseUrl + _url;
        return this.http.get(_url, { withCredentials: true }).pipe(catchError(this.handleError));
    }

    DownloadFile(url:string) {
        this.apiUrl = environment.serviceBaseUrl;
        return this.http.get(this.apiUrl + url, this.httpHeaderFileDownload)
            .pipe(
        );
    }
    
    PostDownload(Url: string, param: any,) {
        this.apiUrl = environment.serviceBaseUrl;
        return this.http.post(this.apiUrl + Url, param, this.httpHeaderFileDownload)
            .pipe();
    }

    DownloadFileWithPost(url:string, formData:any) {
        this.apiUrl = environment.serviceBaseUrl;
        return this.http.post(this.apiUrl + url, formData, this.httpHeaderFileDownload)
            .pipe(catchError(this.handleError)
        );
    }



    GetVisitPath(_url: string) {
        _url = _url;
        return this.http.post(_url, this.httpHeaderFileDownload).pipe(catchError(this.handleError));
    }

    LogPageAnalytics(url:string) {
        return this.http.jsonp(url, "JSONP_CALLBACK")
            .pipe();
    }

    GetUserDetails(url: string, ExpectedRole: any) {
        if (this.appToken.getSessionToken().length <= 0) {
            this.spinnerService.ChangeProgressStatus(true);
            this.Login().subscribe((data: any) => {
                if (data.IsAuthenticated) {
                    this.appToken.setSessionToken(data);
                    this.referralURL = url;
                    if (this.referralURL == null || this.referralURL == '') {
                        this.route.navigate(['/home']);
                    } else {
                        this.isRole = false;
                        this.roleList = data.Roles.split(',');
                        ExpectedRole.forEach((element: string) => {
                            if (data.IsAuthenticated && this.roleList.indexOf(element) >= 0) {
                                this.isRole = true;
                            }
                        });
                        if (!this.isRole) {
                            this.route.navigate(['/error/4']);
                        } else {
                            this.route.navigate([this.referralURL]);
                            this.referralURL = '';
                        }
                    }
                } else {
                    this.route.navigate(['/error/1']);
                }
            }, (error: Response) => {
                if (error.status <= 0) {
                    this.route.navigate(['/error/2']);
                } else if (error.status === 401) {
                    this.route.navigate(['/error/1']);
                } else {
                    this.route.navigate(['/error/2']);
                }
            }, () => {
                this.spinnerService.ChangeProgressStatus(true);
            });
        } else {
            this.route.navigate(['/home']);
        }
    }
}

@Injectable()
export class UIBlockingStatus {
    private IsBlocked!: BehaviorSubject<boolean>;
    // constructor() {
    //     this.IsBlocked = new BehaviorSubject(false);
    // }

    setStatus(_IsBlocked: boolean) {
        this.IsBlocked.next(_IsBlocked);
    }

    getStatus(): Observable<boolean> {
        return this.IsBlocked.asObservable();
    }
}
